import type { SVGProps } from "react";
const SvgEuro = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            d="M10.826 1.5c1.96 0 3.732.855 5.007 2.235a.703.703 0 1 1-.953 1.033v.009c-1.026-1.155-2.468-1.87-4.054-1.87-2.327 0-4.343 1.54-5.194 3.75h5.429a.703.703 0 0 1 0 1.405H5.267a6.7 6.7 0 0 0 0 1.876h5.794a.703.703 0 0 1 0 1.406H5.632c.85 2.21 2.867 3.75 5.194 3.75 1.586 0 3.028-.716 4.054-1.87a.74.74 0 0 1 .493-.193.703.703 0 0 1 .46 1.235l.098-.109C14.65 15.6 12.837 16.5 10.826 16.5c-3.116 0-5.758-2.162-6.68-5.156H2.622a.703.703 0 0 1 0-1.406H3.85a8 8 0 0 1 0-1.876H2.623a.703.703 0 0 1 0-1.406h1.522C5.068 3.662 7.71 1.5 10.826 1.5"
        />
    </svg>
);
export default SvgEuro;
